import { motion } from "framer-motion";

const eur = (n) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);

const ProgressBar = ({ stats, compact = false }) => {
  if (!stats) {
    return (
      <div data-testid="donation-progress-loading" className="animate-pulse">
        <div className="h-3 w-full rounded-full bg-slate-200" />
      </div>
    );
  }
  return (
    <div data-testid="donation-progress" className="w-full">
      <div className="flex flex-wrap items-end justify-between gap-2">
        <p className="font-heading text-2xl sm:text-3xl font-extrabold text-[#0F2C59]" data-testid="donation-collected">
          {eur(stats.collected)}
          <span className="ml-2 text-sm font-semibold text-slate-500">
            récoltés sur {eur(stats.target)}
          </span>
        </p>
        <span
          data-testid="donation-percent"
          className="rounded-full bg-[#ECFDF5] px-3 py-1 text-sm font-bold text-[#047857]"
        >
          {stats.percent} %
        </span>
      </div>
      <div
        className="mt-3 h-3.5 w-full overflow-hidden rounded-full bg-slate-200"
        role="progressbar"
        aria-valuenow={stats.percent}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="Progression de la collecte"
      >
        <motion.div
          className="h-full rounded-full bg-gradient-to-r from-[#0284C7] to-[#10B981]"
          initial={{ width: 0 }}
          whileInView={{ width: `${stats.percent}%` }}
          viewport={{ once: true }}
          transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
        />
      </div>
      {!compact && (
        <p className="mt-3 text-sm font-medium text-slate-500" data-testid="donation-goal-label">
          {stats.label}
        </p>
      )}
    </div>
  );
};

export default ProgressBar;
